import { Component, OnInit } from '@angular/core';
import { MemberListService } from '../../services/memberlist.service';

import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { OtppopupComponent } from '../otppopup/otppopup.component';
import { ImgpopupComponent } from '../imgpopup/imgpopup.component';
import { AddressformComponent } from '../addressform/addressform.component';
import { InfoformComponent } from '../infoform/infoform.component';
import { DetailformComponent } from '../detailform/detailform.component';
import { CardholderformComponent } from '../cardholderform/cardholderform.component';
import { NewmemberService } from '../../services/newmember.service';
import { MembersauditlogComponent } from '../membersauditlog/membersauditlog.component';
import { EcardComponent } from '../ecard/ecard.component';
import { DatePipe, Location } from '@angular/common';
import { PurchasehistoryComponent } from '../purchasehistory/purchasehistory.component';
import { AddonmemberComponent } from '../addonmember/addonmember.component';
import { ConfirmationService } from 'primeng/api';
import { MobilenumberupdateComponent } from '../mobilenumberupdate/mobilenumberupdate.component';
import { MemberRevokeComponent } from '../memberrevoke/memberrevoke.component';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-viewmember',
  templateUrl: './viewmember.component.html',
  styleUrls: ['./viewmember.component.css'],
  providers: [DialogService]
})
export class ViewmemberComponent implements OnInit {


  member: any = {};
  primaryMemberInfo: any = {};
  addOnMemberInfo: Object[] = [];
  mismatchDocuments: any = [];
  mismatchDoc: any = {};
  showGSTContainer: boolean = false;
  showComments: boolean = false;
  otpFlag: boolean = false;
  populateForm: any = {};
  expiredOraboutToExpire: boolean = false;
  renew: boolean = false;
  adProgressBar: boolean = false;
  pageSpinner: boolean = false;
  loginId: string;
  onHoldMismatchReasons: any = {};
  privileges: any = {};
  mismatchReasons: any = [];
  mismatchExpand: boolean = false;
  addonEdit: number = 0;
  accIndex: number;
  canPrimaryEdit: boolean = false;
  canAddOnEdit: boolean = false;
  addonCount: number = 0;
  showEcardLink: boolean = false;
  addonQCcheck: boolean = false;
  isPhotoAvailable: boolean = false;
  isRenewal:boolean = false;
  validateLicense: boolean = false;
  thirdPartyCheck: String = '';

  constructor(private us: UserService,
    private datePipe: DatePipe,
    private ms: MemberListService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    
    public dialogService: DialogService,
    public nms: NewmemberService,
    public loc: Location,
    public messageService: MessageService,
    public confirmationService: ConfirmationService) {
  }

  ngOnInit() {
   
    
    this.pageSpinner = true; // show spinner
   
    let memberId = this.activatedRoute.snapshot.params.memberId;
    let mamemberId = this.activatedRoute.snapshot.params.mamemberId;
    this.userLogin();
  }

  userLogin() {
    localStorage.setItem('userPrefLang', 'en');
    this.us.getUserContent().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        localStorage.setItem("token", res.response);
        localStorage.setItem("currDate", res.responseDateTime);
        this.nms.formFill().subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            this.populateForm = res.response;
          }
        }, err => {
          console.error('ERROR', err);
        });

        this.fetchData();
    this.pageSpinner = false; // hide spinner
    this.setOnHoldReasons();
      }
    });
  }

  setOnHoldReasons() {
    this.onHoldMismatchReasons.documentClear = 'Document UnClear';
    this.onHoldMismatchReasons.licenseType = 'License Type';
    this.onHoldMismatchReasons.licenseNumber = 'License Number';
    this.onHoldMismatchReasons.businessName = 'Business Name';
    this.onHoldMismatchReasons.businessAddress = 'Business Address';
    this.onHoldMismatchReasons.licenseState = 'License State';
    this.onHoldMismatchReasons.expiryDate = 'Expiry Date';
    this.onHoldMismatchReasons.licenseHolder = 'Authorization Form Not Submitted';
    this.onHoldMismatchReasons.primaryMemberMatch = 'Primary Member Name Not Present';
    this.onHoldMismatchReasons.businessNameMatch = 'Business Name';
    this.onHoldMismatchReasons.primaryMemberSigned = 'Primary Member Not Signed';
    this.onHoldMismatchReasons.memberIdentityMatch = 'Photo Mismatch with ID Proof';
    this.onHoldMismatchReasons.IDNumberMatch = 'Photo ID Number';
    this.onHoldMismatchReasons.memberName = 'Member Name';
    this.onHoldMismatchReasons.memberDOB = 'Date Of Birth';
    this.onHoldMismatchReasons.primaryNameMatch = 'Primary Member Name Not Present';
    this.onHoldMismatchReasons.businessOwnerSign = 'Business Owner Not Signed';
  }


  constructMismatchFields(missingFields, documentType, documentText) {
    let documentMismatch: any = {};

    if (missingFields !== null && missingFields !== '') {
      documentMismatch.documentType = documentText + documentType;
      documentMismatch.mismatchFields = missingFields.split(',null').join('');
      this.mismatchReasons.push(documentMismatch);
    }
  }

  fetchData() {
    let maMembershipId = localStorage.getItem('ma');
    if (maMembershipId == null) {
     // this.router.navigateByUrl('/');
    }
    let documentMismatch: any = {};
    this.ms.getMemberActiveInfo(this.activatedRoute.snapshot.params.mamemberId, 'A',
      this.activatedRoute.snapshot.params.memberId).subscribe((res: any) => {
        if (res.code == "SUCCESS" && res.response != null && res.response.currStatCode != "DRAFT") {
          this.nms.setDefault(res.response.membershipNbr, res.response.maMembershipId, res.response.currStatCode);
          this.validateLicense=false;
          this.addonCount = 0;
          this.addOnMemberInfo = [];
          this.member = res.response;
          if (res.response.currStatCode == "ONHOLD") {
            this.mismatchReasons = [];
            for (var licIndex in res.response.memberBusinessLicense) {
              documentMismatch = {};
              var businessLic = res.response.memberBusinessLicense[licIndex];
              this.constructMismatchFields(businessLic.qcReviewMismatchValues,
                businessLic.licenseName, "Business License: ");
            }

            for (var supportIndex in res.response.supportingDocuments) {
              documentMismatch = {};
              var supportDocument = res.response.supportingDocuments[supportIndex];
              this.constructMismatchFields(supportDocument.qcReviewMismatchValues,
                supportDocument.documentType.replace(/_/g, ' '), "Declaration: ");
            }
            if (res.response.authorizationDocument != null) {
              documentMismatch = {};
              var authorizeDoc = res.response.authorizationDocument;
              this.constructMismatchFields(authorizeDoc.qcReviewMismatchValues,
                authorizeDoc.documentType, "");
            }

          }
          for (var licIndex in res.response.memberBusinessLicense) {
            var businessLic = res.response.memberBusinessLicense[licIndex];
            if((this.member.currStatCode === 'ONHOLD' || this.member.currStatCode === 'E')
             && businessLic.thirdPartyCheck === 'INVALID'){
              this.validateLicense=true;
            }
          }
          this.adProgressBar = false; // hide spinner
          this.member = res.response;
          this.primaryMemberInfo = {};

          let cardInfo = res.response.cardHolderInfo;
          this.addOnMemberInfo = [];
          this.showEcardLink = false;
          if (res.response.currStatCode !== "QC PENDING") {
            this.otpFlag = true;
          } else {
            this.otpFlag = false;
          }
          for (var index = 0; index < cardInfo.length; index++) {
            if (cardInfo[index].cardHolderType == "P"
             && (cardInfo[index].status === "ONHOLD" || cardInfo[index].status === "A" || cardInfo[index].status == 'QC PENDING' || cardInfo[index].status == 'P')) {
              this.primaryMemberInfo = cardInfo[index];

              var primaryMemberDocList = this.primaryMemberInfo.cardHolderDocuments;
              if (cardInfo[index].status === "A" || cardInfo[index].status === "ONHOLD") {
                this.canPrimaryEdit = true;
              }
              
              for (var docIndex in primaryMemberDocList) {
                if (primaryMemberDocList[docIndex].documentType == "PHOTO" && primaryMemberDocList[docIndex].documentId != null 
                && primaryMemberDocList[docIndex].documentId != "") {
                  cardInfo[index].isPhotoAvailable = true;
                  if (cardInfo[index].status === "A") {
                    this.isPhotoAvailable = true;
                  }
                }
                this.constructMismatchFields(primaryMemberDocList[docIndex].qcReviewMismatchValues,
                  primaryMemberDocList[docIndex].documentType, "Primary Member: ");              
              }
            } else {
              if (cardInfo[index].cardHolderType === "A" 
                && (cardInfo[index].status === "P" || cardInfo[index].status === "QC PENDING" || cardInfo[index].status === 'A' 
                || cardInfo[index].status === 'DRAFT' || cardInfo[index].status === 'ONHOLD')) {
                this.addonCount++;
              }
              if (cardInfo[index].cardHolderType === "A" && (cardInfo[index].status === "P" || cardInfo[index].status === "A" || cardInfo[index].status === 'DRAFT')) {
                this.canAddOnEdit = true;
              }
              if(cardInfo[index].status === "QC PENDING" && cardInfo[index].cardHolderType == "A") {
                this.addonQCcheck = true;
              }
              this.addOnMemberInfo.push(cardInfo[index]);
              var addOnMemberList = cardInfo[index];
              var addOnMemberDocList = addOnMemberList.cardHolderDocuments;
              for (var docIndex in addOnMemberDocList) {
                if (addOnMemberDocList[docIndex].documentType == "PHOTO" && addOnMemberDocList[docIndex].documentId != null 
                && addOnMemberDocList[docIndex].documentId != "") {
                  cardInfo[index].isPhotoAvailable = true;
                  if (cardInfo[index].status === "A") {
                    this.isPhotoAvailable = true;
                  }
                }
                this.constructMismatchFields(addOnMemberDocList[docIndex].qcReviewMismatchValues,
                  addOnMemberDocList[docIndex].documentType, "Addon Member (" + addOnMemberList.cardHolderNbr + "): ");
              }
            }
          }
        } else {
          this.adProgressBar = false; // hide spinner
          this.router.navigateByUrl("/");
        }
      }, err => {        
        
        console.error('ERROR', err);
      });
  }

  revokeMem() {
    let data: any = {};

    data.nbr = this.primaryMemberInfo.phoneNbr;
    data.revokeBy = 'self';
    if (this.primaryMemberInfo.phoneNbr
      && this.primaryMemberInfo.phoneNbr.toString().length == 10 && this.primaryMemberInfo.phoneNbr.toString().charAt(0) > 4) {
      var otpInfo: any = {};
      otpInfo.phoneNbr = this.primaryMemberInfo.phoneNbr;
      otpInfo.maMembershipId = this.primaryMemberInfo.maMembershipId;
      otpInfo.category = "MEMBERSHIP_REVOKE_OTP";

      const ref = this.dialogService.open(OtppopupComponent, {
        data: otpInfo,
        header: 'OTP Verification',
        width: '80%',
        height: '70%',
        styleClass: 'resFix'
      });
      ref.onClose.subscribe((status: any) => {
        if (status) {
          const revokePopup = this.dialogService.open(MemberRevokeComponent, {
            data: data,
            header: 'Membership Revoke',
            width: '95%',
            height: '90%',
            styleClass: 'memberRevFix',
            closeOnEscape: false
          });
          revokePopup.onClose.subscribe((am: any) => {
            if (am) {
              this.adProgressBar = true; // show spinner
              this.fetchData();
            }
          });
        }
      });
    } else {
      //this.ref.close();
      this.msgToast('Mobile number not valid, Contact support');
    }
  }

terminateMem() {
    let data: any = {};
    data.nbr = this.primaryMemberInfo.phoneNbr;
    data.revokeBy = 'admin';
    const revokePopup = this.dialogService.open(MemberRevokeComponent, {
      data: data,
      header: 'Membership Revoke',
      width: '65%',
      height: '75%',
      closeOnEscape: false
    });
    revokePopup.onClose.subscribe((am: any) => {
      if (am) {
          this.msgToastInfo('Membership status is updated to QC Pending.');
          this.adProgressBar = true; // show spinner
          this.fetchData();
      }
    });
  }

 enableEdit(action) {
    if (!this.otpFlag) {
      if (this.primaryMemberInfo.phoneNbr
        && this.primaryMemberInfo.phoneNbr.toString().length == 10 && this.primaryMemberInfo.phoneNbr.toString().charAt(0) > 4) {
        var otpInfo: any = {};
        otpInfo.phoneNbr = this.primaryMemberInfo.phoneNbr;
        otpInfo.maMembershipId = this.primaryMemberInfo.maMembershipId;
        otpInfo.category = "ENABLE_EDIT_OTP";

        const ref = this.dialogService.open(OtppopupComponent, {
          data: otpInfo,
          header: 'OTP Verification',
          width: '500px',
          height: '250px',
          closeOnEscape: false
        });
        ref.onClose.subscribe((status: any) => {
          if (status) {
            this.nms.formFill().subscribe((res: any) => {
              if (res.code == "SUCCESS") {
                this.populateForm = res.response;
                this.mockLicenseType();
                this.otpFlag = true;
                if (action == "renew") {
                  this.renew = true;
                  this.editDetails();
                }
              }
            }, err => {
              console.error('ERROR', err);
            });
          }
        });
      } else {
        //this.ref.close();
        this.msgToast('Mobile number not valid, Contact support');
      }
    }
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Member Edit', detail: msg });
  }

  msgToastInfo(msg) {
    this.messageService.add({ severity: 'info', summary: 'Member Edit', detail: msg });
  }

  newAddon() {
    this.nms.formFill().subscribe((res: any) => {
      if (res.code === 'SUCCESS') {
        this.populateForm = res.response;
        var licenseType = this.populateForm.businessLicense.filter(proj => proj.code === "SCER");
        if (licenseType[0] != null) {
          licenseType[0].text = "SHOP AND COMMERCIAL ESTABLISHMENT REGISTRATION";
        }
        let data: any = {};
        data.populateForm = this.populateForm;
        data.count = this.addOnMemberInfo.length + 1;
        data.am = {};
        data.address = this.member.memberAddresses;
        data.addonList = this.member.cardHolderInfo;
        data.pmPhone = this.primaryMemberInfo.phoneNbr;
        const ref = this.dialogService.open(AddonmemberComponent, {
          data: data,
          header: 'Create Add-on',
          width: '95%',
          height: '80%',
          closeOnEscape: false
        });
        ref.onClose.subscribe((am: any) => {
          if (am) {
            this.adProgressBar = true; // show spinner
            this.fetchData();
          }
        });
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  viewmoreMismatch() {
    this.mismatchExpand = !this.mismatchExpand;
  }


  editInfo() {
    let data: any = {};
    data.populateForm = this.populateForm;
    data.memberDetails = this.member;
    data = JSON.parse(JSON.stringify(data));
    const ref = this.dialogService.open(InfoformComponent, {
      data: data,
      header: 'Business Owner Details',
      width: '80%',
      height: '80%'
    });
    ref.onClose.subscribe((status: any) => {
      if (status) {
        this.adProgressBar = true; // show spinner
        this.fetchData();
      }
    });
  }

  removeUnderScore(text) {
    return text.replace(/_/g, ' ')
  }

  editDetails() {
    let data: any = {};
    let title: string;
    if (this.renew) {
      title = 'Business Details Renew';
      data.action = 'renew';
    } else {
      title = 'Business Details Edit';
      data.action = 'update';
    }
    data.populateForm = this.populateForm;
    data.memberDetails = this.member;
    this.nms.primaryMemberInfo = this.primaryMemberInfo;
    data = JSON.parse(JSON.stringify(data));
    const ref = this.dialogService.open(DetailformComponent, {
      data: data,
      header: title,
      width: '95%',
      height: '80%',
	  closeOnEscape: false
    });
    ref.onClose.subscribe((status: any) => {
      if (status) {
        this.adProgressBar = true; // show spinner
        this.fetchData();
      }
    });
  }

  editAddress() {
    let data: any = {};
    data.populateForm = this.populateForm;
    data.memberDetails = this.member;
    data = JSON.parse(JSON.stringify(data));
    const ref = this.dialogService.open(AddressformComponent, {
      data: data,
      header: 'Business Address Edit',
      width: '95%',
      height: '70%',
	  closeOnEscape: false
    });
    ref.onClose.subscribe((status: any) => {
      if (status) {
        this.adProgressBar = true; // show spinner
        this.fetchData();
      }
    });
  }

  showCommentsDialog() {
    let data: any = {};
    data.membershipNbr = this.member.membershipNbr;
    const ref = this.dialogService.open(MembersauditlogComponent, {
      data: data,
      header: 'Comments',
      width: '95%',
      height: '75%',
      closeOnEscape: false
    });
  }

  showPurchaseHistory() {
    let data: any = {};
    data.populateForm = this.populateForm;
    data.membershipNbr = this.member.membershipNbr;
    const ref = this.dialogService.open(PurchasehistoryComponent, {
      data: data,
      header: 'Purchase History',
      width: '95%',
      height: '90%',
      closeOnEscape: false
    });
  }

  showEcard(cardInfo) {
    if (cardInfo.photoIdStateCode == null || cardInfo.photoTypeCode == null || cardInfo.photoTypeText == null || cardInfo.photoIdNbr == null || cardInfo.addressLine2 == "" || cardInfo.cityName == "" || cardInfo.dateOfBirth == "" || !cardInfo.phoneNbr || !cardInfo.postalCode || cardInfo.stateProvCode == "") {
      this.msgToast('Add-On Member mandatory details are not available. Please update in the edit section.');
      return;
    }
    let data: any = {};
    data.populateForm = this.populateForm;
    data.cardHolderInfo = cardInfo;
    data.businessName = this.member.businessName;
    if (cardInfo.cardHolderType === "P") {
      data.startDate = this.member.startDate;
    } else {
      data.startDate = cardInfo.createdTs;
    }
    data.membershipNbr = this.member.membershipNbr;
    data.nextRenewDate = this.member.nextRenewDate;
    data.otpFlag = this.otpFlag;
    const ref = this.dialogService.open(EcardComponent, {
      data: data,
      header: 'Member Ecard',
      width: '425px',
      height: '440px',
      closeOnEscape: false
    });
    ref.onClose.subscribe(() => {
      var temp = document.getElementById('cardImg');
      if (temp) {
        document.body.removeChild(temp);
      }
      this.fetchData();
    });
  }

  updateContact(info) {
    this.nms.formFill().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        this.populateForm = res.response;
        var licenseType = this.populateForm.businessLicense.filter(proj => proj.code === "SCER");
        if (licenseType[0] != null) {
          licenseType[0].text = "SHOP AND COMMERCIAL ESTABLISHMENT REGISTRATION";
        }
        let data: any = {};
        data.otpFlag = this.otpFlag;
        data.info = info;
        data.primaryCardholderNbr = this.primaryMemberInfo.cardHolderNbr;
        data.populate = this.populateForm;
        const ref = this.dialogService.open(MobilenumberupdateComponent, {
          data: data,
          header: 'Change Mobile Number',
          width: '700px',
          height: '80%',
          closeOnEscape: false
        });
        ref.onClose.subscribe((status: any) => {
          if (status) {
            this.nms.formFill().subscribe((res: any) => {
              if (res.code == "SUCCESS") {
                this.fetchData();
              }
            }, err => {
              console.error('ERROR', err);
            });
          }
        });
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  mockLicenseType() {
    // Temp method
    var licenseType = this.populateForm.businessLicense.filter(proj => proj.code === "SCER");
    if (licenseType[0] != null) {
      licenseType[0].text = "SHOP AND COMMERCIAL ESTABLISHMENT REGISTRATION";
    }
  }

  editAddon(info) {
    if (info.phoneNbr && info.phoneNbr.toString().length == 10 && info.phoneNbr.toString().charAt(0) > 4) {
      var otpInfo: any = {};
      otpInfo.phoneNbr = info.phoneNbr;
      otpInfo.maMembershipId = info.maMembershipId;
      otpInfo.category = "ENABLE_EDIT_OTP";
      const ref = this.dialogService.open(OtppopupComponent, {
        data: otpInfo,
        header: 'OTP Verification',
        width: '80%',
        height: '70%',
        styleClass: 'resFix',
        closeOnEscape: false
      });
      ref.onClose.subscribe((status: any) => {
        if (status) {
          this.nms.formFill().subscribe((res: any) => {
            if (res.code === 'SUCCESS') {
              this.populateForm = res.response;
              this.mockLicenseType();
              this.addonEdit = info.cardHolderNbr;
              
            }
          }, err => {
            console.error('ERROR', err);
          });
        }
      });
    } else {
      // this.ref.close();
      this.msgToast('Mobile number not valid, Contact support');
    }
  }

  editCardHolder(id) {
    let data: any = {};
    data.cardId = id;
    data.populateForm = this.populateForm;
    data.memberDetails = this.member;
    data.pnumber = this.primaryMemberInfo.phoneNbr;
    data.editContact = false;
    data = JSON.parse(JSON.stringify(data));
    const ref = this.dialogService.open(CardholderformComponent, {
      data: data,
      header: 'Card Holder Edit',
      width: '95%',
      height: '90%',
      styleClass: 'cardOverFlowFix',
      closeOnEscape: false
    });
    ref.onClose.subscribe((status: any) => {
      if (status) {
        this.adProgressBar = true; // show spinner
        this.fetchData();
      }
    });
  }

  editContact(id) {
    let data: any = {};
    data.cardId = id;
    data.populateForm = this.populateForm;
    data.memberDetails = this.member;
    data.pnumber = this.primaryMemberInfo.phoneNbr;
    data.editContact = true;
    data = JSON.parse(JSON.stringify(data));
    const ref = this.dialogService.open(CardholderformComponent, {
      data: data,
      header: 'Card Holder Edit',
      width: '95%',
      height: '90%',
      styleClass: 'cardOverFlowFix',
      closeOnEscape: false
    });
    ref.onClose.subscribe((status: any) => {
      if (status) {
        this.adProgressBar = true; // show spinner
        this.addonEdit = 0;
        this.fetchData();
      }
    });
  }

  confirmEdit() {
    let docUnavail = 0;
    if (!this.member.memberBusinessLicense || this.member.memberBusinessLicense.length == 0 || !this.primaryMemberInfo.cardHolderDocuments || this.primaryMemberInfo.cardHolderDocuments.length == 0) {
      docUnavail = 1;
    } else {
      for (let list of this.member.memberBusinessLicense) {
        if (!list.documentId) {
          docUnavail = 1;
        }
      }
      var photo = this.primaryMemberInfo.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO");
      var photoProof = this.primaryMemberInfo.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO PROOF");
        
        if (photo[0]) {
          if (!photo[0].documentId) {
            docUnavail = 1;
          }
        } else {
          docUnavail = 1;
        }
        if (photoProof[0]) {
          if (!photoProof[0].documentId) {
            docUnavail = 1;
          }
        } else {
          docUnavail = 1;
        }
    }

    for (let lic of this.member.memberBusinessLicense) {
      if(lic.licenseType == 'GST') {
        this.thirdPartyCheck = lic.thirdPartyCheck;
      }
    }
    if (this.thirdPartyCheck== 'INVALID'){
      this.messageService.add({ severity: 'error', summary: 'GST Validation', detail: 'License uploaded is not valid' });
    } else {
    if (docUnavail == 0) {
      this.confirmationService.confirm({
        message: 'Membership status will be updated to QC Pending. No changes are allowed until QC Review. Press "Yes" to confirm.',
        acceptLabel: 'Yes',
        rejectLabel: 'Cancel',
        accept: () => {
          this.nms.confirmEdit().subscribe((res: any) => {
            if (res.code === 'SUCCESS' && res.response != null) {
              this.otpFlag = false;
              if (res.response.status === 'QC PENDING') {
                // this.router.navigateByUrl('/statuscheck');
                this.fetchData();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Member Edit',
                  detail: 'Successfully submitted for QC review'
                });
              }
            }
          }, err => {
            console.error('ERROR', err);
          });
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Member Edit', detail: 'Mandatory documents missing in Business Details/Primary Member fields' });
    }
  }
  }

  showLicenseDocument(details) {
    if (details.documentId === null) {
      this.messageService.add({ severity: 'warn', summary: 'Membership', detail: 'Document is not available' });
      return;
    }
    this.nms.fetchFiles(details.documentId).subscribe((res: any) => {
      if (res.code === 'SUCCESS') {
        details.files = [];
        for (let list of res.response.filesList) {
          let temp: any = {};
          temp.vaultId = list.vaultId;
          temp.img64 = list.file;
          details.files.push(temp);
        }
        const ref = this.dialogService.open(ImgpopupComponent, {
          data: details,
          header: 'Document Viewer',
          width: '80%',
          height: '80%',
          closeOnEscape: false
        });
      }
    }, err => {
      console.error('ERROR', err);
    });
  }
}

